export default function (phrase) {
    // @TODO
    // do the thing
    return phrase
}